import { TabConfig } from '@/app/navigation/types'
import { ReportsTab } from '../tabs/reports'

export const clientTabs: TabConfig[] = [
  {
    id: 'reports',
    label: 'Rapports',
    icon: 'DocumentIcon',
    component: ReportsTab,
    path: '/client/reports',
    position: 1,
    permissions: ['view_reports']
  }
]